import {Component, Prop, Vue} from "vue-property-decorator";
import {Tab, Tabs} from "~/components/tabs";

export enum SettingsTab {
  MapOverlays,
  Metas
}

@Component
export class SettingsNavigationTabs extends Vue {

  @Prop({type: Number, required: true}) value: SettingsTab;

  render() {
    return (
      <Tabs>
        <Tab isActive={this.value === SettingsTab.MapOverlays}
             onClick={() => this.$emit("input", SettingsTab.MapOverlays)}>
          Surcouches de cartes
        </Tab>
        <Tab isActive={this.value === SettingsTab.Metas}
             onClick={() => this.$emit("input", SettingsTab.Metas)}>
          Thématiques
        </Tab>
      </Tabs>
    );
  }

}


// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-070cedd6/navigation-tabs.tsx" });